module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Sushi-9d95722c7bec14bd11a51cd55fd338d67da507d75a4211aa45758f6bf067809f.svg";